import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const UpdateEducationAchievement = ({
  getUserCv,
  userDataId,
  handleCloseUpdateEducationAhievement,
  showUpdateEducationAchievement,
  educationData,
  educationAchievementData,
  ActivityId,
}) => {

  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  const [activity, setActivity] = useState("");
  const [display, setDisplay] = useState(false);
  const [achievement, setAchievement] = useState("");
  const [achievementtDate, setAchievementDate] = useState("");

  const [formChanged, setFormChanged] = useState(false); // Tracks form changes
  const [isSubmitting, setIsSubmitting] = useState(false); // Tracks submission state

  // Handle input changes
  const handleInputChange = (e) => {
    setAchievement(e.target.value);
    setFormChanged(true); // Mark form as changed
  };

  const handleDateChange = (date) => {
    setAchievementDate(date[0]);
    setFormChanged(true); // Mark form as changed
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formChanged || isSubmitting) return; // Prevent submission if unchanged or in progress
    setIsSubmitting(true); // Disable the button during submission

    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      eduId: educationData.usrDataEductnId,
      eduAchvmntId: educationAchievementData.usrDataEduAchvmntId,
      achievement: achievement,
      achievementDate: moment(achievementtDate).format("YYYY-MM-DD"),
    };
    console.log("body", body);
    try {
      const res = await axios.post("/Resume/UpdateEducationAchievement", body);
      toast.success(res.data.message);
      handleCloseUpdateEducationAhievement();
      getUserCv();
      setDisplay(false);
      setAchievement(""); // Reset input
      setAchievementDate(null); // Reset date
      setFormChanged(false); // Disable the button after update
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    } finally {
      setIsSubmitting(false); // Re-enable the button after submission completes
    }

    // }
  };

  useEffect(() => {
    if (educationAchievementData) {
      setAchievement(educationAchievementData.achievement);
      setAchievementDate(educationAchievementData.achivementDate);
    }
  }, [educationAchievementData]);

  return (
    <Modal
      show={showUpdateEducationAchievement}
      onHide={handleCloseUpdateEducationAhievement}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Update education achivement</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseUpdateEducationAhievement}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12} className="mb-2">
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Achievement{" "}<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={achievement}
                // onChange={(e) => setAchievement(e.target.value)}
                onChange={handleInputChange}
                placeholder="Enter Achievement"
                className="Dark-Input-from-group"
              />
              {display && !achievement ? (
                <span className="error_msg_lbl">Add achievement</span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="endYear"  className=" Flatpickr-Calender-Class">
              <Form.Label className="class-type  col-md-12">
                Achievement date{" "}<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Flatpickr
                type="number"
                value={achievementtDate}
                // onChange={(date) => setAchievementDate(date[0])}
                onChange={handleDateChange}
                placeholder="Enter Achievement Date"
                className="Dark-Input-from-group"
                // disabled={isPresent}
                options={{
                  maxDate: new Date(), // Disable future dates
                  static: true, // Keeps the calendar visible on click         
                }}
              />
              {display && !achievementtDate ? (
                <span className="error_msg_lbl">Select achievement date </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
             onClick={handleSubmit}
             style={{cursor: formChanged ? "pointer" : "default"}}
            >
              <a href="#/"
                className={`btn ${!achievement || !achievementtDate || isSubmitting ? "disabled" : "enabled"}`}
                // onClick={!achievement || !achievementtDate || isSubmitting ? (e) => e.preventDefault(): handleSubmit}
                   //onClick={(e) => e.preventDefault()} 
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
              // onClick={handleSubmit}
              >
                {isSubmitting ? "" : "Submit"}
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateEducationAchievement;
